import { usePage } from '@inertiajs/react';

export function useApplyEdition() {
  const { editionShell } = usePage().props;
  if (!editionShell) throw new Error('Application pages require an event shell');
  return { eventSlug: editionShell.slug, eventCity: editionShell.city };
}
